// 默认发言人头像
const defaultSpeakerAvatar =
  'https://img.alicdn.com/imgextra/i2/O1CN0116Ium71VLL7pBuRI0_!!6000000002636-2-tps-339-339.png';
// 未修改发言人名称的头像(8在第一位)
const splitedSpeakerAvatarList = [
  'https://img.alicdn.com/imgextra/i1/O1CN01AVOzFA1UV7xvwGrGb_!!6000000002522-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i2/O1CN01V5s4Ja1dfxsaBRdCX_!!6000000003764-2-tps-339-340.png',
  'https://img.alicdn.com/imgextra/i4/O1CN01odxoO01xMXOVZ6Pvg_!!6000000006429-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i2/O1CN01AwOFQX1jhEfmob7zt_!!6000000004579-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i2/O1CN01reRFBM1VhK80fwPqj_!!6000000002684-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i3/O1CN01qB4Huw1pi34P50dlV_!!6000000005393-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i3/O1CN01CmaoS91T9lshjcAJv_!!6000000002340-2-tps-349-350.png',
  'https://img.alicdn.com/imgextra/i4/O1CN01aa3Wf21hxbb6F8fol_!!6000000004344-2-tps-348-349.png',
];

// 已修改发言人名称的头像(8在第一位)
const editNameSpeakerAvatarList = [
  'https://img.alicdn.com/imgextra/i4/O1CN01YWYvdp1c0SNPncPhh_!!6000000003538-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i1/O1CN01AQvPYW1T2RYKQjxDp_!!6000000002324-2-tps-339-340.png',
  'https://img.alicdn.com/imgextra/i1/O1CN01IVbqlf1U1ocprZanT_!!6000000002458-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i1/O1CN015o7rn41lSEwdaGw3p_!!6000000004817-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i4/O1CN01wlHL9o1LPmoRRr1wq_!!6000000001292-2-tps-348-349.png',
  'https://img.alicdn.com/imgextra/i1/O1CN01iVTmPJ28sYrxfQGT3_!!6000000007988-2-tps-348-348.png',
  'https://img.alicdn.com/imgextra/i4/O1CN01mJ8FTD1PMMJONVSa5_!!6000000001826-2-tps-349-349.png',
  'https://img.alicdn.com/imgextra/i1/O1CN01n9SXOp28fHNpq3vKI_!!6000000007959-2-tps-348-349.png',
];
// 已修改发言人头像背景颜色
const editNameSpeakerAvatarBgColorList = [
  '#57714B',
  '#C00101',
  '#BE9000',
  '#1F5CA2',
  '#328A71',
  '#514596',
  '#B55899',
  '#C95402',
];

export {
  defaultSpeakerAvatar,
  splitedSpeakerAvatarList,
  editNameSpeakerAvatarList,
  editNameSpeakerAvatarBgColorList,
};
